// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"PR","innerWrapper":"QR","tooltipWrapper":"RR","icon":"SR","tooltip":"TR","content":"UR"};